import React, { useRef, useState, forwardRef } from "react";
import { FaEnvelopeOpenText } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import "./SendMessage.css";

export const SendMessage = forwardRef((props, ref) => {
  const form = useRef();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [formError, setFormError] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();

    const name = form.current.user_name.value.trim();
    const message = form.current.message.value.trim();
    const email = form.current.user_email.value.trim();

    if (!name) {
      setFormError("Por favor, insira o seu nome.");
      return;
    } else if (!email) {
      setFormError("Por favor, insira o seu email.");
      return;
    } else if (!message) {
      setFormError("Por favor, insira a sua mensagem.");
      return;
    } else {
      setFormError(null);
    }

    emailjs
      .sendForm(
        "service_wxh6swe",
        "template_t3ywmhs",
        form.current,
        "eGwO2Bs60GT7YpfAJ"
      )
      .then(
        (result) => {
          console.log(result.text);
          setShowSuccessMessage(true);
        },
        (error) => {
          console.log(error.text);
          setFormError(
            "Ocorreu um problema ao enviar a sua mensagem. Por favor, tente mais tarde."
          );
        }
      );

    form.current.reset();
  };

  const handleNameChange = () => {
    setFormError(null);
  };

  return (
    <section ref={ref} className="send-message-section">
      <div className="send-message-container">
        <div className="send-message-intro">
          <p className="send-message-eyebrow">Contacto direto</p>
          <h2 className="send-message-header">Se preferir, envie-nos uma mensagem por aqui.</h2>
          <p className="send-message-lead">
            Responda com o máximo de contexto que considerar útil. Quanto mais clara
            for a informação inicial, mais rapidamente conseguimos encaminhar a sua solicitação.
          </p>
        </div>

        <div className="send-message-card">
          <div className="send-message-card-header">
            <div className="send-message-icon">
              <FaEnvelopeOpenText />
            </div>
            <div>
              <h3>Formulário de contacto</h3>
              <p>Responderemos com a maior brevidade possível.</p>
            </div>
          </div>

          {showSuccessMessage && (
            <div className="success-message slide-from-top">
              Mensagem enviada com sucesso!
            </div>
          )}
          {formError && (
            <div className="error-message slide-from-bottom">{formError}</div>
          )}

          <form ref={form} onSubmit={sendEmail} className="send-message-form">
            <label htmlFor="contact-name">Nome</label>
            <input id="contact-name" type="text" name="user_name" onChange={handleNameChange} />
            <label htmlFor="contact-email">Email</label>
            <input id="contact-email" type="email" name="user_email" />
            <label htmlFor="contact-message">Mensagem</label>
            <textarea id="contact-message" name="message" />
            <input type="submit" value="Enviar mensagem" />
          </form>
        </div>
      </div>
    </section>
  );
});
